import { useCallback, useMemo, useState } from "react";
import checkInFlowCopy, {
  CHECK_IN_COPY_SCREENS,
} from "../copy/checkInFlowCopy";

export const CHECK_IN_LANG = {
  EN: "en",
  ES: "es",
};

export function useCheckInLanguage(screen) {
  if (!CHECK_IN_COPY_SCREENS.includes(screen)) {
    throw new Error(`useCheckInLanguage: pantalla desconocida "${screen}"`);
  }

  const [lang, setLang] = useState(CHECK_IN_LANG.EN);

  const setEnglish = useCallback(() => setLang(CHECK_IN_LANG.EN), []);
  const setSpanish = useCallback(() => setLang(CHECK_IN_LANG.ES), []);

  const copy = useMemo(
    () => checkInFlowCopy[lang][screen],
    [lang, screen]
  );

  return {
    lang,
    setLang,
    setEnglish,
    setSpanish,
    copy,
    isEnglish: lang === CHECK_IN_LANG.EN,
    isSpanish: lang === CHECK_IN_LANG.ES,
  };
}

export default useCheckInLanguage;
